import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/static/illustrations/onboarding/biggest-planet.svg'
import _imports_1 from '../../../../assets/static/illustrations/onboarding/smallest-planet.svg'
import _imports_2 from '../../../../assets/static/illustrations/onboarding/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-703cb861"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout__interests" }
const _hoisted_3 = ["disabled", "id", "onChange", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageBox = _resolveComponent("MessageBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MessageBox, {
      class: _normalizeClass(['layout__message', { reverse: $props.animationIsReverse }]),
      message: $props.message
    }, null, 8, ["class", "message"]),
    _createElementVNode("img", {
      class: _normalizeClass(['layout__biggest-planet', { reverse: $props.animationIsReverse }]),
      src: _imports_0,
      alt: "Planeta grande"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass(['layout__smallest-planet', { reverse: $props.animationIsReverse }]),
      src: _imports_1,
      alt: "Planeta pequeno"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass([
        'layout__astronaut',
        { 'fluctuate-facing-right': $setup.isTransitionFinished },
        { reverse: $props.animationIsReverse }
      ]),
      src: _imports_2,
      alt: "Astronauta",
      onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fluctuate && $setup.fluctuate(...args)))
    }, null, 34),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.interests, (interest, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "layout__interest",
          key: index
        }, [
          _createElementVNode("label", {
            class: _normalizeClass([
            'layout__label',
            {
              disable: $setup.hasEnough && !$setup.selectedInterestsIDs.includes(interest.id)
            },
            {
              selected: $setup.selectedInterestsIDs.includes(interest.id)
            }
          ])
          }, [
            _createElementVNode("input", {
              disabled: $setup.hasEnough && !$setup.selectedInterestsIDs.includes(interest.id),
              class: "layout__check-box",
              type: "checkbox",
              id: interest.id,
              onChange: ($event: any) => ($setup.selectInterest($event.target, interest.id)),
              checked: 
              $setup.selectedInterestsIDs.map(value => value).includes(interest.id)
            
            }, null, 40, _hoisted_3),
            _createTextVNode(" " + _toDisplayString(interest.title), 1)
          ], 2)
        ]))
      }), 128))
    ])
  ]))
}